import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Sidebar from '../components/dashboard/Sidebar';
import AdminApplications from './admin/AdminApplications';
import AdminSets from './admin/AdminSets';
import AdminCreators from './admin/AdminCreators';
import AdminSetDetail from './admin/AdminSetDetail';

const AdminDashboard = () => {
    return (
        <div className="flex min-h-screen bg-[#f8f8f8]">
            {/* Sidebar */}
            <Sidebar role="admin" />

            {/* Main Content Area */}
            <div className="flex-1 ml-64 p-8">
                <Routes>
                    <Route path="/" element={<AdminApplications />} />
                    <Route path="/creators" element={<AdminCreators />} />
                    <Route path="/sets" element={<AdminSets />} />
                    <Route path="/sets/:id" element={<AdminSetDetail />} />
                </Routes>
            </div>
        </div>
    );
};

export default AdminDashboard;
